import { IFormItemActionTypes } from './../../action-types/form/IFormItemActionTypes';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eFormItemActionTypeIds } from '../../action-types/form/IFormItemActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { apiWrapper } from "../../../api/apiWrapper";

import { IFormItem, IFormItemVm } from '../../../models/response/form/IFormItem';


export function* formItemSaga(): any {
    yield takeLatest(eFormItemActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eFormItemActionTypeIds.SELECT_START, selectWorker)
    yield takeEvery(eFormItemActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFormItemActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eFormItemActionTypeIds.SAVES_START, savesWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.formWrapper.formItem.load)
    if (res.is_success) {
        yield put(actions.formWrapper.formItem.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.formWrapper.formItem.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* selectWorker(data: any): any {
    const res: IBaseResponeModel = yield call([apiWrapper.formWrapper.formItem, apiWrapper.formWrapper.formItem.select], data.payload)
    if (res.is_success) {
        yield put(actions.formWrapper.formItem.SELECT_SUCCESS(res.data))
    } else {
        yield put(actions.formWrapper.formItem.SELECT_ERROR(res.message ?? "Error"))
    }
}
function* saveWorker(action: IFormItemActionTypes): any {
    const payload: IFormItem = action.payload as IFormItem;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.formWrapper.formItem.update, payload)
    } else {
        res = yield call(apiWrapper.formWrapper.formItem.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.formWrapper.form.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.formWrapper.form.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IFormItemActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.formWrapper.formItem.delete, payload)
    if (res.is_success) {
        yield put(actions.formWrapper.form.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.formWrapper.form.DELETE_ERROR(res.message ?? "Error"))
    }
}
function* savesWorker(action: IFormItemActionTypes): any {
    const payload: IFormItem[] = action.payload as IFormItem[];
    const res: IBaseResponeModel = yield call(apiWrapper.formWrapper.formItem.updates, payload)
    if (res.is_success) {
        yield put(actions.formWrapper.formItem.SAVES_SUCESS(payload))
    } else {
        yield put(actions.formWrapper.formItem.SAVES_ERROR(res.message ?? "Error"))
    }
}
